import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Material/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Material/Issue3";
import Issue4 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Material/Issue4";
import Issue5 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson15/Material/Issue5";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson15MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson15Material = (props: Lesson15MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue3 issue={props.findIssue && props.findIssue(3)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue4 issue={props.findIssue && props.findIssue(4)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue5 issue={props.findIssue && props.findIssue(5)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson15Material;
